// Side cart — przechwytuje formularze /cart/add, otwiera sections/cart-drawer.liquid
// i odświeża jego zawartość przez Section Rendering API (bez przeładowania strony).
(function () {
  var SECTION_ID = 'cart-drawer';
  var CLOSE_MS = 450;

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var errorEl = drawer.querySelector('[data-cart-drawer-error]');
  var statusEl = drawer.querySelector('[data-cart-drawer-status]');
  var lastFocus = null;
  var closeTimer = null;
  var changeController = null;

  function content() {
    return drawer.querySelector('[data-cart-drawer-content]');
  }

  function announce(message) {
    if (!statusEl) return;
    statusEl.textContent = '';
    window.requestAnimationFrame(function () {
      statusEl.textContent = message;
    });
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message || '';
    errorEl.hidden = !message;
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count-badge]').forEach(function (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }

  // Podmienia zawartość drawera i przywraca fokus na odpowiadający element.
  function render(sectionHtml) {
    var current = content();
    if (!sectionHtml || !current) return;

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var next = doc.querySelector('[data-cart-drawer-content]');
    if (!next) return;

    var active = document.activeElement;
    var focusKey = null;
    var focusQty = null;
    if (active && current.contains(active)) {
      var item = active.closest('[data-cart-drawer-item]');
      focusKey = item ? item.getAttribute('data-key') : null;
      focusQty = active.getAttribute('data-cart-drawer-qty');
    }

    current.replaceWith(next);
    updateCount(parseInt(next.getAttribute('data-cart-count'), 10) || 0);

    if (!drawer.open || !active || !current.contains(active)) return;
    var target = null;
    if (focusKey) {
      var nextItem = next.querySelector('[data-cart-drawer-item][data-key="' + CSS.escape(focusKey) + '"]');
      if (nextItem && focusQty) target = nextItem.querySelector('[data-cart-drawer-qty="' + focusQty + '"]');
    }
    target = target || drawer.querySelector('[data-cart-drawer-close]');
    if (target) target.focus();
  }

  function open() {
    window.clearTimeout(closeTimer);
    if (!drawer.open) {
      lastFocus = document.activeElement;
      drawer.showModal();
      document.documentElement.classList.add('cart-drawer-lock');
      // Wymuś layout w pozycji startowej, żeby transform się animował.
      void drawer.offsetWidth;
    }
    drawer.classList.add('is-open');
  }

  function close() {
    if (!drawer.open) return;
    drawer.classList.remove('is-open');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      drawer.close();
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : CLOSE_MS);
  }

  drawer.addEventListener('close', function () {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-lock');
    showError('');
    if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  });

  // Escape: zamknij z animacją zamiast natychmiastowego close().
  drawer.addEventListener('cancel', function (event) {
    event.preventDefault();
    close();
  });

  drawer.addEventListener('click', function (event) {
    // Klik w backdrop trafia w sam <dialog> (panel wypełnia go w całości).
    if (event.target === drawer || event.target.closest('[data-cart-drawer-close]')) {
      close();
      return;
    }

    var qtyBtn = event.target.closest('[data-cart-drawer-qty]');
    var removeLink = event.target.closest('[data-cart-drawer-remove]');
    var item = event.target.closest('[data-cart-drawer-item]');
    if (!item || (!qtyBtn && !removeLink)) return;

    event.preventDefault();
    var currentQty = parseInt(item.getAttribute('data-quantity-value'), 10) || 0;
    var nextQty = removeLink ? 0 : Math.max(0, currentQty + parseInt(qtyBtn.getAttribute('data-cart-drawer-qty'), 10));
    change(item.getAttribute('data-key'), nextQty);
  });

  function change(key, quantity) {
    if (changeController) changeController.abort();
    changeController = new AbortController();
    var current = content();
    if (current) current.classList.add('is-busy');
    showError('');

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: [SECTION_ID],
        sections_url: window.location.pathname
      }),
      signal: changeController.signal
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showError(result.data.description || result.data.message || 'Nie udało się zaktualizować koszyka.');
          var stale = content();
          if (stale) stale.classList.remove('is-busy');
          return;
        }
        render(result.data.sections && result.data.sections[SECTION_ID]);
        announce(quantity === 0 ? 'Usunięto produkt z koszyka.' : 'Zaktualizowano ilość.');
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        showError('Nie udało się zaktualizować koszyka. Spróbuj ponownie.');
        var stale = content();
        if (stale) stale.classList.remove('is-busy');
      });
  }

  function refresh() {
    return fetch(root + '?sections=' + SECTION_ID, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (sections) { render(sections[SECTION_ID]); })
      .catch(function () {});
  }

  function addToCart(form, submitter) {
    var button = submitter || form.querySelector('[type="submit"]');
    if (button) {
      if (button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    }
    showError('');

    var body = new FormData(form);
    body.append('sections', SECTION_ID);
    body.append('sections_url', window.location.pathname);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          // Np. brak na stanie — pokaż komunikat w drawerze z aktualnym koszykiem.
          showError(result.data.description || result.data.message || 'Nie udało się dodać produktu do koszyka.');
          return refresh().then(open);
        }
        render(result.data.sections && result.data.sections[SECTION_ID]);
        open();
        announce('Dodano do koszyka' + (result.data.product_title ? ': ' + result.data.product_title : '') + '.');
      })
      .catch(function () {
        // Bez sieci / błąd JS — klasyczny submit jako fallback.
        form.submit();
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
        }
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    event.preventDefault();
    addToCart(form, event.submitter);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-drawer-open]');
    if (!trigger) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    open();
  });

  // Powrót z bfcache — koszyk mógł się zmienić w innej karcie.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
})();
